module.exports = __webpack_public_path__ + "img/Gallery_1_09.5da7052b.jpeg";